import type { Route } from 'fitify-ui-onboarding/src/types/routeTypes'

import type { DidYouKnowPlacement } from 'types/state'

const DID_YOU_KNOW_PATH_SEGMENT = '/did-you-know-'

const PLACEMENT_ANCHOR: Record<Exclude<DidYouKnowPlacement, 'none'>, string> = {
  motivation_early: '/motivation-early',
  life_events_stopped: '/eligibility-pitch',
}

/**
 * Repositions the three "Did You Know" routes based on the resolved placement
 * experiment value. The value is read from state (see PagesSideEffects)
 *
 * Defensive: a no-op (returns the routes unchanged) when the funnel has no
 * "Did You Know" routes, and drops them when the target anchor is missing.
 */
export const applyDidYouKnowPlacement = (
  routes: readonly Route<string>[],
  placement: DidYouKnowPlacement | undefined
): Route<string>[] => {
  const didYouKnowRoutes = routes.filter((route) =>
    route.path.includes(DID_YOU_KNOW_PATH_SEGMENT)
  )

  if (didYouKnowRoutes.length === 0) {
    return [...routes]
  }

  const baseRoutes = routes.filter(
    (route) => !route.path.includes(DID_YOU_KNOW_PATH_SEGMENT)
  )

  if (placement === undefined || placement === 'none') {
    return baseRoutes
  }

  const anchorIndex = baseRoutes.findIndex((route) =>
    route.path.endsWith(PLACEMENT_ANCHOR[placement])
  )

  if (anchorIndex === -1) {
    return baseRoutes
  }

  return [
    ...baseRoutes.slice(0, anchorIndex + 1),
    ...didYouKnowRoutes,
    ...baseRoutes.slice(anchorIndex + 1),
  ]
}
